<template>
  <div class="uk-padding-top">
    <div class="uk-margin-top footer">
      All rights reserved | DNZ-PROJECTS ©
      {{new Date().getFullYear()}}
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
@import "../assets/vars.less";

.footer {
  padding: 0.3rem;
  font-size: .8rem;
  background: @primary-background-color;
  border-top: 1px solid @border-color;
  color: rgb(165, 165, 165);
  padding-left: 10rem;
}
</style>
